import React, { useState } from "react";
import TopTabComponent from "../../../../../../components/TopTabComponent/TopTabComponent";
import { Table } from "antd";
import { TextComponent } from "../../../../../../components";
import styles from "./BasicInfo.module.css";

const BasicInfo = () => {
  const [parameterData, setParameterData] = useState([
    {
      parameters: "Bake Temperature (Fahrenheit)",
      data: "Numeric",
      value: "45",
    },
    {
      parameters: "Time (minutes)",
      data: "Numeric",
      value: "250",
    },
  ]);

  const columns = [
    {
      title: "Parameters",
      dataIndex: "parameters",
      key: "parameters",
      render: (text, record) => (
        <TextComponent className={styles.materialText} text={`${text}.`} />
      ),
    },
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      render: (text) => (
        <div className={styles.ingredientCell}>
          <span>{text}</span>
        </div>
      ),
    },
  ];

  const options = [
    { id: 1, name: "Program 1" },
    { id: 2, name: "Program 2" },
    { id: 3, name: "Program 3" },
  ];
  const [focusedTab, setFocusedTab] = useState(options[0]);

  return (
    <div className={styles.mainDetCont}>
      {/* ///////////////////left side details/////////////// */}
      <div className={styles.leftSideCont}>
        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Machine Category"}
          />
          <TextComponent
            fontFamily={"Inter-semiBold"}
            text={"Mixing, Oven, Proof / Chill"}
          />
        </div>

        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Machine Type"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"Automatic"} />
        </div>

        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Recommended Operator"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"02"} />
        </div>

        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Skill Level"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"Expert"} />
        </div>
        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Maintenance Due(Days)"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"3"} />
        </div>
        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Minimum Weight Capacity"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"200 Ibs"} />
        </div>
        <div>
          <TextComponent
            fontFamily={"Inter-semiBold"}
            className={styles.leftProText}
            text={"Maximum Weight Capacity"}
          />
          <TextComponent fontFamily={"Inter-semiBold"} text={"300 Ibs"} />
        </div>
      </div>

      {/* ///////////////////right side details/////////////// */}
      <div className={styles.rightSideCont}>
        <TopTabComponent
          options={options}
          focused={focusedTab}
          setFocused={setFocusedTab}
          TopTabListStyle={styles.TopTabListStyle1}
        />
        <div className={styles.TableDiv}>
          <Table
            scroll={{ x: true }}
            columns={columns}
            dataSource={parameterData}
            pagination={false}
            rowKey="parameters"
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
